// extracted by mini-css-extract-plugin
export default {"pageContainer":"NotFound_pageContainer__71-b+","bigText":"NotFound_bigText__r4YIs"};